module.exports = __webpack_public_path__ + "img/plus-big.d42a2e6f.svg";